type LeaveFaqEntryEventArgs = {
  faqEntryId: number
  faqAccessChannel: string | null
  initialPageScrollDepth: number
  maxPageScrollDepth: number
  totalViewTime: number
  helpCenterSessionId: string
}

type LeaveFaqEntryEventExtra = {
  faq_entry_id: number
  faq_access_channel: string | null
  initial_page_scroll_depth: number
  max_page_scroll_depth: number
  total_view_time: number
  help_center_session_id: string
}

export const leaveFaqEntryEvent = (args: LeaveFaqEntryEventArgs) => {
  const extra: LeaveFaqEntryEventExtra = {
    faq_entry_id: args.faqEntryId,
    faq_access_channel: args.faqAccessChannel,
    initial_page_scroll_depth: args.initialPageScrollDepth,
    max_page_scroll_depth: args.maxPageScrollDepth,
    total_view_time: args.totalViewTime,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'user.leave_faq_entry',
    extra,
  }
}
